import { Routes } from '@angular/router';

import { SocialAdminComponent } from './components/social-admin/social-admin.component';

export const SOCIAL_ROUTES: Routes = [{
	path: 'Social', component: SocialAdminComponent
}];
